import { render, staticRenderFns } from "./transition-router.vue?vue&type=template&id=0a38a8f8&scoped=true&"
import script from "./transition-router.vue?vue&type=script&lang=js&"
export * from "./transition-router.vue?vue&type=script&lang=js&"
import style0 from "./transition-router.vue?vue&type=style&index=0&id=0a38a8f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a38a8f8",
  null
  
)

export default component.exports